<template>
  <div class="title">
    <em></em>
    <p>{{ title }}</p>
  </div>
</template>

<script>
export default {
  name: "detatilTitle",
  props:[
      'title'
  ],
}
</script>

<style scoped lang="less">
.title {
  margin-top: 24px;
  em {
    width: 4px;
    height: 24px;
    background: #999999;
    display: inline-block;
    vertical-align: middle;
    margin-right: 15px;
  }
  p {
    display: inline-block;
    font-size: 22px;
    font-weight: 500;
    vertical-align: middle;
    height: 30px;
    line-height: 30px;
  }
}
</style>
